<template>
  <div class="qm-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'QmCard',
}
</script>
<style></style>
